import request from '@/utils/request'
//今日产量
export function workCountCurDay() {
  return request({
    url: '/api/out/kanban/workCountCurDay',
    method: 'get'
  })
}
//今日计划产量
export function workPlanCountCurDay() {
  return request({
    url: '/api/out/kanban/workPlanCountCurDay',
    method: 'get'
  })
}
//今日发货量
export function outCountCurDay() {
  return request({
    url: '/api/out/kanban/outCountCurDay',
    method: 'get'
  })
}
//今日计划发货量
export function outPlanCountCurDay() {
  return request({
    url: '/api/out/kanban/outPlanCountCurDay',
    method: 'get'
  })
}
//年度累计扫码量
export function scanCountCurYear() {
  return request({
    url: '/api/out/kanban/scanCountCurYear',
    method: 'get'
  })
}
//历史累计扫码次数
export function scanCountALL() {
  return request({
    url: '/api/out/kanban/scanCountALL',
    method: 'get'
  })
}
//今日扫码量
export function scanCountCurDay() {
  return request({
    url: '/api/out/kanban/scanCountCurDay',
    method: 'get'
  })
}
//今日窜货预警数
export function scanWarningCountCurDay() {
  return request({
    url: '/api/out/kanban/scanWarningCountCurDay',
    method: 'get'
  })
}
//年度累计窜货预警数
export function scanWarningCountCurYear() {
  return request({
    url: '/api/out/kanban/scanWarningCountCurYear',
    method: 'get'
  })
}
//近30天每日产量和发货量趋势
export function workAndOutCount30Day() {
  return request({
    url: '/api/out/kanban/workAndOutCount30Day',
    method: 'get'
  })
}
//近30天用户扫码分布
export function scanConsumer30DayByArea() {
  return request({
    url: '/api/out/kanban/scanConsumer30DayByArea',
    method: 'get'
  })
}
//当前年用户扫码分布
export function scanConsumerCurYearByArea() {
  return request({
    url: '/api/out/kanban/scanConsumerCurYearByArea',
    method: 'get'
  })
}
//30天扫码数量统计
export function scanConsumer30DayByDate() {
  return request({
    url: '/api/out/kanban/scanConsumer30DayByDate',
    method: 'get'
  })
}
//30天扫码产品统计
export function scanConsumer30DayByProduct() {
  return request({
    url: '/api/out/kanban/scanConsumer30DayByProduct',
    method: 'get'
  })
}
//当前年用户异地扫码分布
export function warningScanConsumerCurYearByArea() {
  return request({
    url: '/api/out/kanban/warningScanConsumerCurYearByArea',
    method: 'get'
  })
}
//30天异地扫码数量统计
export function warningScanConsumer30DayByDate() {
  return request({
    url: '/api/out/kanban/warningScanConsumer30DayByDate',
    method: 'get'
  })
}
//30天异地扫码产品统计
export function warningScanConsumer30DayByProduct() {
  return request({
    url: '/api/out/kanban/warningScanConsumer30DayByProduct',
    method: 'get'
  })
}
//近30天窜货预警分布
export function scanInspect30DayByArea() {
  return request({
    url: '/api/out/kanban/scanInspect30DayByArea',
    method: 'get'
  })
}
//当前年窜货预警分布
export function scanInspectCurYearByArea() {
  return request({
    url: '/api/out/kanban/scanInspectCurYearByArea',
    method: 'get'
  })
}
//30天窜货预警数量统计
export function scanInspect30DayByDate() {
  return request({
    url: '/api/out/kanban/scanInspect30DayByDate',
    method: 'get'
  })
}
//30天窜货预警产品统计
export function scanInspect30DayByProduct() {
  return request({
    url: '/api/out/kanban/scanInspect30DayByProduct',
    method: 'get'
  })
}
//当日工厂生产、发货进度
export function factoryWorkOutCountCurDay() {
  return request({
    url: '/api/out/kanban/factoryWorkOutCountCurDay',
    method: 'get'
  })
}
//疑似窜货事件总数
export function scanInspectAllCount() {
  return request({
    url: '/api/out/kanban/scanInspectAllCount',
    method: 'get'
  })
}
//本周新增预警数
export function scanInspectOneWeek() {
  return request({
    url: '/api/out/kanban/scanInspectOneWeek',
    method: 'get'
  })
}
//当日出库订单数
export function outBillCountCurDay() {
  return request({
    url: '/api/out/kanban/outBillCountCurDay',
    method: 'get'
  })
}
//当日出库商品数
export function outBillProductCountCurDay() {
  return request({
    url: '/api/out/kanban/outBillProductCountCurDay',
    method: 'get'
  })
}
//近7天平均出库数量
export function outBillAverageCount7Day() {
  return request({
    url: '/api/out/kanban/outBillAverageCount7Day',
    method: 'get'
  })
}
//出库扫码率
export function scanRateOfShipmentsCurDay() {
  return request({
    url: '/api/out/kanban/scanRateOfShipmentsCurDay',
    method: 'get'
  })
}
//当月出库数量趋势图
export function outBillCountCurMonth() {
  return request({
    url: '/api/out/kanban/outBillCountCurMonth',
    method: 'get'
  })
}
//当月发货产品数
export function outBillProductCountCurMonth() {
  return request({
    url: '/api/out/kanban/outBillProductCountCurMonth',
    method: 'get'
  })
}
//近30天发货扫码率趋势图
export function scanRateOfShipments30Day() {
  return request({
    url: '/api/out/kanban/scanRateOfShipments30Day',
    method: 'get'
  })
}
